import EyeOutline from "~icons/eva/eye-outline"
import DownloadOutline from "~icons/eva/download-outline"
import FileFill from "~icons/eva/file-fill"
import styles from "./styles.module.scss"
import { useStores } from "../../../models/helpers/useStores"
import { observer } from "mobx-react-lite"

type FileType = "confirmation" | "document" | "image"

export type FileData = {
  thumbnail?: string
  userId: string
  fileName: string
  fileURL: string
  sharedBy: string
  uploadDate: string
  type: FileType
}

const FileItem = observer(
  ({ file, handlePreview }: { file: FileData; handlePreview: () => void }) => {
    const rootStore = useStores()
    const isLoggedInUser = rootStore.loggedInUser.id === file.userId

    const handleDownload = () => {
      fetch(file.fileURL)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement("a")
          link.href = url
          link.download = file.fileName || "downloaded-file"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Error fetching the file:", error)
        })
    }

    return (
      <div className={styles.fileItem}>
        <div className={styles.thumbnail}>
          {file.thumbnail ? (
            <img src={file.thumbnail} alt={file.fileName} />
          ) : (
            <div className={styles.iconWrapper}>
              <FileFill className={styles.fileIcon} />
            </div>
          )}
        </div>
        <div className={styles.details}>
          <p className={styles.fileName}>
            {file.fileName.length > 25
              ? `${file.fileName.substring(0, 12)}...${file.fileName.substring(
                  file.fileName.length - 12,
                )}`
              : file.fileName}
          </p>
          <p className={styles.sharedInfo}>
            Shared by {isLoggedInUser ? "you" : file.sharedBy} on {file.uploadDate}
          </p>
        </div>
        <div className={styles.actions}>
          <button className={styles.viewButton} onClick={handlePreview}>
            <EyeOutline className={styles.actionIcon} />
          </button>
          <button className={styles.downloadButton} onClick={handleDownload}>
            <DownloadOutline className={styles.actionIcon} />
          </button>
        </div>
      </div>
    )
  },
)

export default FileItem
